import { sanityClient } from './client';
import { urlFor } from './image';

const TAG_TO_CATEGORY = {
  primavera: 'Primavera (Pasqua)',
  estate: 'Estate',
  autunno: 'Autunno',
  inverno: 'Inverno (Natale)',
  'amiche-di-amy': 'Amiche di Amy',
};

const productQuery = `*[_type == "product"] | order(_createdAt desc) {
  _id,
  _createdAt,
  title,
  description,
  tag,
  coverImage,
  images,
  etsyUrl,
  etsyUrl,
  youtubeUrl,
  "patternPdfUrl": patternPdf.asset->url,
  "patternPdfUrls": patternPdfs[].asset->url
}`;

const toProject = (doc) => {
  const coverUrl = doc.coverImage ? urlFor(doc.coverImage).width(1200).fit('max').auto('format').url() : null;
  const imageUrls = Array.isArray(doc.images)
    ? doc.images
      .filter(Boolean)
      .map((img) => urlFor(img).width(1200).fit('max').auto('format').url())
    : [];

  const gallery = [coverUrl, ...imageUrls].filter(Boolean);

  return {
    id: doc._id,
    title: doc.title,
    // For compatibility with existing UI props
    category: TAG_TO_CATEGORY[doc.tag] || doc.tag || 'Tutti',
    tag: doc.tag,
    img: coverUrl || imageUrls[0] || '',
    gallery,
    longDescription: doc.description,
    description: doc.description,
    description: doc.description,
    etsyLink: doc.etsyUrl,
    tutorialLink: doc.youtubeUrl,
    patternPdfUrl: doc.patternPdfUrl, // Legacy single string
    patternPdfUrls: [...(doc.patternPdfUrls || []), doc.patternPdfUrl].filter(Boolean), // Unified array of URLs
    hasPattern: Boolean(doc.patternPdfUrl) || (Array.isArray(doc.patternPdfUrls) && doc.patternPdfUrls.length > 0),
    createdAt: doc._createdAt,
  };
};

export async function fetchProducts() {
  // If env is missing, skip fetch to avoid noisy errors in local/dev
  if (!process.env.REACT_APP_SANITY_PROJECT_ID) return [];
  const docs = await sanityClient.fetch(productQuery);
  return Array.isArray(docs) ? docs.map(toProject) : [];
}
